import { React, useEffect, useState } from "react";

function ImageViewerView(props) {
  //window dimension
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    //add event listner
    window.addEventListener("resize", handleResize);
    //relase
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //handle window resize
  const handleResize = () => {
    //set dimension
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //callback
    props.onClose();
  };

  return (
    //show hide loading view
    <div className="pb-5">
      {/* Top bar */}
      <div className="bg-light border-bottom sticky-top">
        <div className="d-flex">
          <button
            type="button"
            className="btn btn-transparent"
            onClick={resetScreen}
          >
            <img
              loading="lazy"
              src="./images/arrow-left-short.svg"
              alt="back"
              style={{ width: "30px", height: "auto" }}
            ></img>
          </button>
          {/* Title */}
          <label className="fs-3 ms-2 py-2 text-secondary fs-4">
            {props.title ?? "Image Viewer"}
          </label>
        </div>
      </div>

      {/* Image */}
      <div className="mt-5 text-center">
        <img
          loading="lazy"
          alt="preivew_img"
          src={URL.createObjectURL(props.file)}
          style={{
            maxWidth:
              windowDimensions.width > windowDimensions.height
                ? "auto"
                : windowDimensions.width - 40,
            maxHeight:
              windowDimensions.width < windowDimensions.height
                ? "auto"
                : windowDimensions.height - 40,
          }}
        />
      </div>
    </div>
  );
}

export default ImageViewerView;
